const _version = "3.8.8"
function version() {
    return _version
}
export default version
